export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const POPULATE_CATEGORIES = 'POPULATE_CATEGORIES';

export const FETCH_LEVERANCIERS = 'FETCH_LEVERANCIERS'
export const POPULATE_LEVERANCIERS = 'POPULATE_LEVERANCIERS';

export const TOGGLE_CATEGORY_FILTER = 'TOGGLE_CATEGORY_FILTER';

export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';